'use strict';

// console.log('running estimatedShipping.js');

var estimatedShippingData = {
    shipZip: null,
    shippingEstimateState: '',
    dtTargetTime: null,
    locale: ''
};

if (typeof pdpCurrentLocale === 'string') {
    estimatedShippingData.locale = pdpCurrentLocale;
}

/**
 * Sets up the estimated UPS shipping date widget.
 */
function initEstimatedShippingWidget() {
// console.log('running initEstimatedShippingWidget...');
    if ($('#estimated-shipping').length !== 1) {
        return;
    }
    // on page load, check for stored zip, and if it is present, run requestEstimatedDate
    $(document).ready(function() {
        var cookieZip = Cookies.get('shipZip');
        if (cookieZip && cookieZip.length === 5) {
            estimatedShippingData.shipZip = cookieZip;
            submitEstimateDateRequest(estimatedShippingData.shipZip);
        } else {
            $('#estimated-shipping').removeClass('edit-state estimate-state').addClass('load-state');
            estimatedShippingData.shippingEstimateState = 'load-state';
        }
    });

    // bind update button
    $('.js-postal-code-update-button').on('click', function(e) {
        e.preventDefault();
        $('.postal-code-error').removeClass('show-error');
        // console.log('running the click handler on the update button...');
        var zip = $(this).parent().find('input[name=zipcode]').val();
        // console.log('zip=' + zip);
        submitEstimateDateRequest(zip);
    });

    $('input[name=zipcode]').on('focus', function() {
        $('#postal-code-entry').find('input[name=zipcode]').val('');
        $('.faster-shipping-popout').removeClass('popout-open');
        $('.postal-code-error').removeClass('show-error');
    });

    // bind cancel button
    $('.js-cancel-postal-code-update-link').on('click', function(e) {
        e.preventDefault();
        // console.log('running click handler for cancel link');
        // if we were in load state go back to that; if we were in edit state, go back to display state
        var currentState = estimatedShippingData.shippingEstimateState;
        // console.log('currentState=' + currentState);
        var destinationState;
        if (estimatedShippingData.shippingEstimateState === 'load-state') {
            destinationState = 'load-state';
        } else if (estimatedShippingData.shippingEstimateState === 'edit-state') {
            destinationState = 'estimate-state';
        }
        // console.log('destinationState=' + destinationState);
        $('#estimated-shipping').removeClass('edit-state estimate-state load-state').addClass(destinationState + ' show');
        $('#postal-code-entry').find('input[name=zipcode]').val('');
    });

    // bind edit zip button
    $('.js-postal-code-edit-link').on('click', function(e) {
        e.preventDefault();
        updatePostalCodeEntry();
    });

    // bind want it faster button
    $('.faster-link').on('click', function(e) {
        e.preventDefault();
        showFasterShippingPopout();
    });

    // reposition popeout on resize
    // TODO: throttle this
    $(window).on('resize', function() {
        setFasterShippingPopoutPosition();
    });

}

/**
 * Shows or hides the shipping widget based on the CTA present.
 */
function showHideEstimatedShippingWidget() {
// console.log('running showHideEstimatedShippingWidget...');
    if (productAvailable && $('#estimated-shipping').length > 0) {
        $('#estimated-shipping').addClass('show');
    } else {
        $('#estimated-shipping').removeClass('show');
    }
}

/**
 * Gets ready to accept zipcode input
 */
function updatePostalCodeEntry() {
// console.log('running updatePostalCodeEntry...');
    var zipInput = $('#postal-code-entry').find('input[name=zipcode]');
    zipInput.val('');
    $('#estimated-shipping').removeClass('estimate-state load-state').addClass('edit-state show');
    zipInput.focus();
    estimatedShippingData.shippingEstimateState = 'edit-state';
}

/**
 * Converts an api-provided date string in the format YYYYMMDD to a Luxon dateTime
 * @param {string} dateString - api date string
 * @param {string} ianaTimeZone - timezone such as 'America/Los_Angeles'
 * @param {string} locale - two-letter country code such as 'us'
 * @returns {Object} Luxon dateTime object
 */
function dateTimeFromString(dateString, ianaTimeZone, locale) {
// console.log('running dateTimeFromString...');
    var projectedDeliveryDate = new luxon.DateTime.fromObject({
        year: dateString.substr(0, 4),
        month: dateString.substr(4, 2),
        day: dateString.substr(6, 2)
    },
    {
        zone: ianaTimeZone,
        locale: locale.replace('_', '-')
    });
    return projectedDeliveryDate;
}

/**
 * Formats and renders the shipping estimate info in the UI.
 * @param {string} code - the zip code in question
 * @param {string} dateString - the YYYYMMDD string returned from the api
 */
function showEstimatedShippingResult(code, dateString) {
// console.log('running showEstimatedShippingResult...');
    var dtTargetTime;
    var estimateMessage = $('#estimated-shipping').data('result-message');
    $('.shipping-estimate').html(estimateMessage);
    var deliveryDate = dateTimeFromString(dateString, 'America/Los_Angeles', estimatedShippingData.locale);
    // console.log('est delivery date: ' + deliveryDate.toFormat('MMMM dd, yyyy'));

    // get the current pst time
    var dtPstNow = luxon.DateTime.local().setZone('America/Los_Angeles');
    // get the cutoff time for today
    var dtPstCutoffTime = dtPstNow.set({hour: 14, minute: 0});
    // is it past 5 pst yet?
    if (dtPstNow > dtPstCutoffTime) {
        // if so, set target time at 2pm pst on the next weekday AFTER today
        dtTargetTime = getNextWeekdayDateTime(dtPstNow.plus({ days: 1 })).set({ hour: 14, minute: 0 });
    } else {
        // if not, set target time at 2pm pst on the next weekday, including today if it is one
        dtTargetTime = getNextWeekdayDateTime(dtPstNow).set({hour: 14, minute: 0});
    }
    estimatedShippingData.dtTargetTime = dtTargetTime;

    // get the time in minutes from the target time
    var minutesLeft = luxon.Interval.fromDateTimes(dtPstNow, dtTargetTime).length('minutes');
    // convert it to hours and minutes
    var hoursToShow = Math.floor(minutesLeft / 60);
    var minutesToShow = minutesLeft % 60;

    // update the display message
    $('.postal-code-text').text(code);
    $('.order-hours').text(hoursToShow);
    $('.order-minutes').text(minutesToShow);
    $('.estimated-date').text(deliveryDate.toFormat('EEEE, MMMM d'));

    // show the message
    $('#estimated-shipping').removeClass('edit-state load-state').addClass('estimate-state');
    estimatedShippingData.shippingEstimateState = 'estimate-state';
}

/**
 * Returns the soonest weekday from the dateTime given. If the dateTime given is a weekday it returns it unchanged, but if it is not then it returns the next weekday as a dateTime.
 * @param {Object} dtStart - a dateTime object to check
 * @returns {Object} dateTime object representing for the next weekday
 */
function getNextWeekdayDateTime(dtStart) {
// console.log('running getNextWeekdayDateTime...');
    var daysToJump;
    if (dtStart.weekday > 5) {
        daysToJump = 8 - dtStart.weekday;
        return dtStart.plus({ days: daysToJump });
    }
    return dtStart;
}

/**
 * Checks a postal code for basic format, based on the country. Only handles US zip codes at the moment.
 * @param {string} code - the postal code to check
 * @param {string} locale - the locale string for the site, such as 'en_US'
 * @returns {Boolean} true for valid, false for invalid
 */
function validatePostalCode(code, locale) {
// console.log('running validatePostalCode...');
}

/**
 * Performs an ajax call to the API to get a date for the zipcode given
 * @param {string} zipCode - the zipCode to check
 * @returns {string} the dateString from the API
 */
function requestEstimatedDate(zipCode) {
// console.log('running requestEstimatedDate...');
    return requestEstimatedDateMock(zipCode);
}

/**
 * Submits a shipping estimate request
 * @param {string} zip - the zip code in question
 * @param {string} dateString - the YYYYMMDD string returned from the api
 */
function submitEstimateDateRequest(zip) {
// console.log('running submitEstimateDateRequest...');
    var dateString;
    if (validatePostalCode(zip.trim())) {
        dateString = requestEstimatedDate(zip.trim());
    } else {
        console.error('postal code "' + zip + '" could not be processed.');
        $('.postal-code-error').addClass('show-error');
    }
}

/**
 * Mocks the UPS API for testing during development.
 * @param {string} zipCode - the zipCode to check
 * @returns {string} a dateString  as if it came from the API
 */
function requestEstimatedDateMock(zipCode) {
    var dateString = '20220912';
    return dateString;
}
/**
 * Positions the "faster shipping" popout relative to the shipping estimate widget.
 */
function setFasterShippingPopoutPosition() {
// console.log('running setFasterShippingPopoutPosition...');
    var popout = $('.faster-shipping-popout');
    var link = $('.faster-link');
    var linkWidth = link.width();
    var linkHeight = link.height();
    var linkTop = link.position().top;
    var linkLeft = link.position().left;
    var popoutWidth = popout.width();
// console.log('linkWidth=' + linkWidth);
// console.log('linkHeight=' + linkHeight);
// console.log('linkTop=' + linkTop);
// console.log('linkLeft=' + linkLeft);
// console.log('popoutWidth=' + popoutWidth);
    popout.css({
        top: (linkTop + linkHeight + 23) + 'px',
        left: (linkLeft + Math.round(linkWidth / 2) - Math.round(popoutWidth / 2) - 8) + 'px' // -8 for the '?'
    });
}
/**
 * Calculates dates for the "faster shipping" popout and renders and displays the popout.
 */
function showFasterShippingPopout() {
// console.log('running showFasterShippingPopout...');
    var popout = $('.faster-shipping-popout');
    // set fields
    var nextDayOffset = 1;
    var twoDayOffset = 2;
    var threeDayOffset = 3;
    var dtPstNow = luxon.DateTime.local().setZone('America/Los_Angeles');
    var dtPstCutoffTime = dtPstNow.set({ hour: 14, minute: 0 });
    // is it past 5 pst yet?
    if (dtPstNow > dtPstCutoffTime) {
        nextDayOffset += 1;
        twoDayOffset += 1;
        threeDayOffset += 1;
    }
    $('.ship-date-nextday').text(getNextWeekdayDateTime(getNextWeekdayDateTime(luxon.DateTime.local().plus({ days: nextDayOffset }))).toFormat('EEE, MMM d'));
    $('.ship-date-twoday').text(getNextWeekdayDateTime(getNextWeekdayDateTime(luxon.DateTime.local().plus({ days: twoDayOffset }))).toFormat('EEE, MMM d'));
    $('.ship-date-threeday').text(getNextWeekdayDateTime(getNextWeekdayDateTime(luxon.DateTime.local().plus({ days: threeDayOffset }))).toFormat('EEE, MMM d'));
    // set popout position
    setFasterShippingPopoutPosition();
    // reveal popout
    popout.addClass('popout-open');
    // bind closing x
    $('.faster-shipping-closer').on('click', function(e) {
        e.preventDefault();
        popout.removeClass('popout-open');
    });
}
/**
 * Stores a zipcode in a cookie
 * @param {string} zipCode - The zip code
 */
function storeZipCode(zipCode) {
// console.log('running storeZipCode...');
}
/**
 * Retrieves the zipcode from a cookie
 * @returns {string} the zipcode
 */
function retrieveZipCode() {
// console.log('running retrieveZipCode...');
}

// TEMPORARY:
// Let's make these available globally in the browser as I develop, free of the behind-the-scenes modulization of the webpack require system...
window.estimatedShippingData = estimatedShippingData;
window.initEstimatedShippingWidget = initEstimatedShippingWidget;
window.showHideEstimatedShippingWidget = showHideEstimatedShippingWidget;
window.updatePostalCodeEntry = updatePostalCodeEntry;
window.dateTimeFromString = dateTimeFromString;
window.showEstimatedShippingResult = showEstimatedShippingResult;
window.getNextWeekdayDateTime = getNextWeekdayDateTime;
window.validatePostalCode = validatePostalCode;
window.requestEstimatedDate = requestEstimatedDate;
window.requestEstimatedDateMock = requestEstimatedDateMock;
window.setFasterShippingPopoutPosition = setFasterShippingPopoutPosition;
window.showFasterShippingPopout = showFasterShippingPopout;
window.storeZipCode = storeZipCode;
window.retrieveZipCode = retrieveZipCode;
// console.log('luxon.VERSION=' + luxon.VERSION);

$(document).ready(function() {
    if (typeof luxon !== 'undefined') {
        initEstimatedShippingWidget();
    }
});
